/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
/**
 * Act values
 */
export var Act;
(function (Act) {
    Act["MOVE"] = "move";
    Act["SET"] = "set";
    Act["SEQUENCE"] = "sequence";
})(Act || (Act = {}));
/**
 * Description of an Actor
 */
export class ActorDesc {
    constructor() {
        this.objectId = 0; // id of object to manipulate
        this.act = Act.SET; // move | set | sequence
    }
}
//# sourceMappingURL=ActorDesc.js.map